import PageBrandMapView from '@pages/seller-page-brand/map/views/PageBrandMapView.vue';
import { pinia } from '@tools/pinia';
import { createApp } from 'vue';

export const initMap = (): void => {
  createApp(PageBrandMapView)
    .use(pinia)
    .mount('#brand-details-map-app');
};
